module.exports = "https://web-assets.ifttt.com/packs/media/prosumer/svg--check-2f3f345a.svg";